import { apiClient } from "helpers/api_helper";

export const GetCustomerByMobileNo = async (number: any) => {
    try {
        const response = await apiClient.get(`/api/v1/Customer/GetCustomerByMobileNo?mobileNo=${number}`);
        return response;
    } catch (error: any) {
        throw new Error(error);
    }
};

export const SendOtp = async (payload: any) => {
    try {
        const response = await apiClient.post(`/api/v1/otp/SendOtp`,payload);
        return response;
    } catch (error: any) {
        throw new Error(error);
    }
};

export const VerifyOtp = async (payload: any) => {
    try {
        const response = await apiClient.post(`/api/v1/otp/VerifyOtp`,payload);
        return response;
    } catch (error: any) {
        throw new Error(error);
    }
};

export const InsertCustomerReferral = async (payload: any) => {
    try {
        const response = await apiClient.post(`/api/v1/CustomerReferral/InsertCustomerReferral`,payload);
        return response;
    } catch (error: any) {
        throw new Error(error);
    }
};